<template>
    <div id="contenedor-listado-mobiles">
        <template
            v-for="(contrato, index) in contratos">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ contrato.numero }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :id="contrato.id">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    {{ contrato.meta }}
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import CONTRATOS_LOCAL from '@/graphql/querys/local/administracion/contratos/contratos.gql';

export default {
  name: 'ListadoMobiles',
  components: {
  },
  data() {
    return {
    };
  },
  apollo: {
    contratos: {
      query: CONTRATOS_LOCAL,
    },
  },
};
</script>

<style lang="scss">

</style>
